import useFetch from '../../../_fetch'
import { getColumns } from './columns'
import { Table } from '../_table/table'

export default function ReferenceReport() {        
    const { doFetch } = useFetch()
    const columns = getColumns()
    
    return (
        <Table 
            columns={columns} 
            getData={async (fromDate, toDate) => {
                const res = await doFetch('/data/total-transactions-by-ref', {
                    fromDate, toDate, timezoneOffsetMinutes: new Date().getTimezoneOffset()
                })
                if (!res.ok) throw new Error('Reference performance could not be fetched for the selected period.')

                const data = await res.json()
                if (!Array.isArray(data)) throw new Error('The server returned an unexpected reference report format.')
                return data
            }}
            title='Reference Report'
            description='Understand which reference values drive conversions and commission across campaigns.'
            entityLabel='references'
            pageKey='reference-report'
            defaultSort='totalCommission'
        />)
}
